import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { Report as BasicHealthReport } from "src/modules/basic-health";
import { Report as HtxReport } from "src/modules/htx";
import { Report as KtxReport } from "src/modules/ktx";
import { Report as LtxReport } from "src/modules/ltx";

export const Report: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxReport />;
	}
	if (mod === "ktx" || mod === "kd") {
		return <KtxReport />;
	}
	if (mod === "basic_health") {
		return <BasicHealthReport />;
	}
	if (mod === "ltx") {
		return <LtxReport />;
	}
	return null;
};
